import { useDrawer } from '@/core/context/DrawerContext'
import { Header, Wrapper } from './integration.style'
import { IntegrationDetails } from './integrationDetails'
import Typography from '@/ui/components/typography'

const Integration = () => {
    const { drawerState } = useDrawer()
    const {
        contentProps: { integration },
    } = drawerState

    return (
        <Wrapper>
            <Header>
                <Typography component="p" variant="xl-regular">
                    Integration details
                </Typography>
            </Header>
            <IntegrationDetails integration={integration} />
        </Wrapper>
    )
}

export default Integration
